import React from 'react';

function Icon({ className }: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      className={className + ' fill'}
      viewBox="0 0 22 22"
    >
      <path
        fill="#000"
        d="M10.81 21.581c5.953 0 10.79-4.837 10.79-10.79C21.6 4.837 16.763 0 10.81 0 4.855 0 0 4.837 0 10.79c0 5.954 4.856 10.791 10.81 10.791zm0-20.093c5.116 0 9.283 4.168 9.283 9.284 0 5.116-4.167 9.284-9.284 9.284-5.116 0-9.283-4.168-9.283-9.284 0-5.116 4.167-9.284 9.283-9.284z"
      ></path>
      <path
        fill="#000"
        d="M12.652 13.602V9.35c0-.624-.507-1.13-1.13-1.13H9.44c-.623 0-1.13.506-1.13 1.13v1.07c0 .556.402 1.019.93 1.114v2.093a1.133 1.133 0 00-.93 1.113v1.07c0 .624.507 1.131 1.13 1.131h3.052c.624 0 1.131-.507 1.131-1.13v-1.07c0-.58-.423-1.06-.97-1.14zm-.26 2.108h-2.85v-.868h.184a.748.748 0 00.746-.747v-3.028a.748.748 0 00-.746-.746H9.54v-.87h1.88v4.624c0 .412.335.747.746.747h.225v.889zM10.872 7.851c.987 0 1.79-.802 1.79-1.79 0-.986-.803-1.789-1.79-1.789s-1.79.803-1.79 1.79.803 1.79 1.79 1.79zm0-2.347a.559.559 0 11-.002 1.117.559.559 0 01.002-1.117z"
      ></path>
    </svg>
  );
}

Icon.displayName = 'Icon.Info';

export default Icon;
